import apiFetch from '../apiFetch'

export default function (token, dossierId, docList) {
  return apiFetch({ endPoint: `LandingAccess/${dossierId}/CreateRequestAccess`, method: 'POST', body: { documentTypeUseIds: docList }, token: token })
}
